module.exports = __webpack_public_path__ + "img/region_mountain_north.6ec64e59.svg";